export class UrlHandler {
  constructor(private window: Window) {}

  parseQuery(parameter: string): string | null {
    return this.getQueryParameter(parameter);
  }

  private getQueryParameter(param: string): string | null {
    const { search } = this.window.location;
    const regex = new RegExp(`[?&]${param}=([^&#]*)`);
    const matches = regex.exec(search);

    if (matches !== null) {
      return decodeURIComponent(matches[1]);
    } else {
      return null;
    }
  }

  resetRelativeReference(parameter: string): void {
    const {
      document: { title }
    } = this.window;
    this.window.history.replaceState({}, title, this.getResetRelativeReference(parameter));
  }

  getResetRelativeReference(parameter: string): string {
    const {
      location: { pathname, search, hash }
    } = this.window;
    const reducedSearch = this.deleteQueryParameter(search, parameter).replace(new RegExp('^&'), '?');
    return pathname + reducedSearch + hash;
  }

  private deleteQueryParameter(url: string, param: string): string {
    const regex = new RegExp(`[?&]${param}=([^&#]*)`, 'g');
    return url.replace(regex, '');
  }
}
